import { jsx as _jsx } from "react/jsx-runtime";
import { change, touch, formValueSelector } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { PrepaymentSettings } from './prepayment-settings.component';
var selector = formValueSelector('editShop');
export var PrepaymentSettingsContainer = function () {
    var dispatch = useDispatch();
    var selectedPrepaymentOption = useSelector(function (state) { return selector(state, 'selectedPrepaymentOption'); });
    var depositType = useSelector(function (state) { return selector(state, 'settings.depositType'); });
    useEffect(function () {
        if (selectedPrepaymentOption === 'partial-deposit' && !depositType) {
            dispatch(change('editShop', 'settings.depositType', 'percentage'));
            dispatch(touch('editShop', 'settings.depositType'));
        }
        if (selectedPrepaymentOption === 'partial-deposit') {
            dispatch(touch('editShop', 'settings.depositAmount'));
        }
    }, [selectedPrepaymentOption, depositType, dispatch]);
    var selectOption = function (option) {
        if (option !== 'in-person') {
            dispatch(change('editShop', 'requestCardForInPersonPayments', false));
        }
        dispatch(change('editShop', 'selectedPrepaymentOption', option));
    };
    var handleDepositTypeChange = function (newType) {
        dispatch(change('editShop', 'settings.depositType', newType));
        if (newType === 'percentage') {
            dispatch(change('editShop', 'settings.depositAmount', null));
        }
        else {
            dispatch(change('editShop', 'settings.depositPercentage', null));
        }
    };
    var handleDepositValueChange = function (value, type) {
        var numericValue = value === '' ? null : Number(value);
        var fieldName = type === 'percentage' ? 'settings.depositPercentage' : 'settings.depositAmount';
        dispatch(change('editShop', fieldName, numericValue));
    };
    var handleRequestCardChange = function (isNowChecked) {
        dispatch(change('editShop', 'requestCardForInPersonPayments', isNowChecked));
        dispatch(change('editShop', 'bookNoPay', !isNowChecked));
        if (isNowChecked) {
            dispatch(change('editShop', 'allowInPersonPayments', false));
        }
    };
    return (_jsx(PrepaymentSettings, { selectedOption: selectedPrepaymentOption, depositType: depositType, selectOption: selectOption, handleDepositTypeChange: handleDepositTypeChange, handleDepositValueChange: handleDepositValueChange, handleRequestCardChange: handleRequestCardChange }));
};
